// extracted by mini-css-extract-plugin
export default {"zoomModal":"B2-z"};